// extracted by mini-css-extract-plugin
module.exports = {"App":"AboutPage_App__3oxee","AboutPage":"AboutPage_AboutPage__hUy8W","Title":"AboutPage_Title__i6F05","Paragraph":"AboutPage_Paragraph__38Fep","Divider":"AboutPage_Divider__qt-HE"};